import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Browser } from '@capacitor/browser';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'voucher-modal',
  templateUrl: './voucher-modal.component.html',
  styleUrls: ['./voucher-modal.component.scss'],
})
export class VoucherModalComponent implements OnInit {
  @Input() vouchersInfo: any;
  @Input() redirectUrl: string;
  @Input() allowBooking: number;
  @Output() generateVoucherFunction: Function;
  public totalVouchers: number;
  public copiedStates: boolean[];

  constructor(private modalController: ModalController) {}

  ngOnInit() {
    this.totalVouchers = this.vouchersInfo.length;
    this.copiedStates = new Array(this.totalVouchers).fill(false);
  }

  async redeemCode() {
    this.closeModal();
    await Browser.open({ url: this.redirectUrl });
  }

  async generateVoucherTrigger() {
    this.generateVoucherFunction();
    this.closeModal();
  }
  copyToClipboard(text: string, index: number) {
    navigator.clipboard.writeText(text).then(() => {
      this.copiedStates[index] = true;
      setTimeout(() => {
        this.copiedStates[index] = false;
      }, 2000);
    });
  }

  formatDate(dateString: string) {
    const date = new Date(dateString);

    const options: Intl.DateTimeFormatOptions = {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    };
    const formatter = new Intl.DateTimeFormat('en-GB', options);
    const formattedDate = formatter.format(date);
    return formattedDate;
  }
  closeModal() {
    this.modalController.dismiss();
  }
}
